// extracted by mini-css-extract-plugin
export var notificationHost = "_ih-0";